import { render } from "./OverlayModal.vue?vue&type=template&id=171ba513&scoped=true"
import script from "./OverlayModal.vue?vue&type=script&lang=js"
export * from "./OverlayModal.vue?vue&type=script&lang=js"

import "./OverlayModal.vue?vue&type=style&index=0&id=171ba513&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171ba513"]])

export default __exports__